module.exports = __webpack_public_path__ + "static/media/aualogo.f176244a.png";